<template>
  <div class="app-loading" v-if="appLoading">
    <i class="fal fa-spinner-third fa-spin"></i>
  </div>
  <div id="app" v-else>
    <div id="appContent" :class="'theme-' + (getAgencyDisplay.themeColor ? getAgencyDisplay.themeColor : '')">
      <notifications group="saved" position="center top" />
      <GlobalHeader v-if="!hideHeader" />
      
      <router-view />
    </div>
    
    <GlobalFooter v-if="!hideFooter" />
  </div>
  
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data() {
    return {
      appLoading: true,
      hideHeader: this.$route && this.$route.query.hideHeader,
      hideFooter: this.$route && this.$route.query.hideFooter,
    }
  },

  // metaInfo: {
  //   // if no subcomponents specify a metaInfo.title, this title will be used
  //   title: 'Book Discount Travel',
  //   // all titles will be injected into this template
  //   titleTemplate: ''
  // },

  async created () {
    let self = this;

    let agency = window.TravelPlatform.agency;
    let site = window.TravelPlatform.site;
    self.$store.dispatch('setAgencyRef', {agency: agency});
    self.$store.dispatch('setSiteRef', {site: site});

    if(self.getAgencyDisplay.customStyles) {
      let css = self.getAgencyDisplay.customStyles;
      let head = document.head || document.getElementsByTagName('head')[0];
      let style = document.createElement('style');
      head.appendChild(style);

      style.rel = 'text/css';
      if (style.styleSheet){
        // This is required for IE8 and below.
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    if(self.getAgencyDisplay.faviconUrl) {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = self.getAgencyDisplay.faviconUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    if(self.getAgencyDisplay.customJavascript) {
      let js = self.getAgencyDisplay.customJavascript;
      let head = document.head || document.getElementsByTagName('head')[0];
      let script = document.createElement("script");
      let inlineScript = document.createTextNode(js);
      script.appendChild(inlineScript); 
      head.appendChild(script);
    }

    setTimeout(() => {
      self.appLoading = false;
    }, 1000);
  },

  computed: {
    ...mapGetters ([
      'getAgencyDisplay',
      'getAgencyName'
    ])
  }
}
</script>